import type React from "react";
import { useParams } from "react-router-dom";
import { useTalentDetail } from "../../../hooks/use-talents-api";
import { TalentDetailPage } from "./TalentDetailPage";

/**
 * タレント詳細ページのコンテナコンポーネント
 * @return {React.ReactElement} タレント詳細ページ
 */
const TalentDetailPageContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { talent, loading, error } = useTalentDetail(id);

  return <TalentDetailPage talent={talent} loading={loading} error={error} />;
};

export default TalentDetailPageContainer;
